let API_BASE_URL, NODE_CHATGPT;
const OPENAI_API_KEY = 'sk-proj-8zFBmpYqJBceoq7LvedRT3BlbkFJt4kEBwTVpSZAw6bCUH2p';

// Cette partie sert à définir l'environnement depuis le code est exécuté, si on est en local, on part du
// principe que le serveur nodeJS qui tourne est en local, sinon c'est en prod.
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    API_BASE_URL = 'http://localhost:4008';
    NODE_CHATGPT = 'http://localhost:2000';
} else {
    API_BASE_URL = 'https://x.solution-digitale.ch';
    NODE_CHATGPT = 'https://x.solution-digitale.ch';
}

export { API_BASE_URL, NODE_CHATGPT , OPENAI_API_KEY };